/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserPlus} from '@fortawesome/pro-duotone-svg-icons';

const AddStaffIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faUserPlus} {...props} />
);

export default AddStaffIcon;
